import React, { Children, cloneElement, isValidElement, type ReactElement, type ReactNode } from 'react'
import { Size } from '@front/model'
import { Stack, type StackProps } from '@mantine/core'

type Props = {
  children: ReactNode
  divider: ReactNode
} & StackProps

export const TStack = ({ children, divider, ...props }: Props): ReactElement => {
  const validChildren = Children.toArray(children).filter(isValidElement)

  return (
    <Stack {...props} gap={props.gap ?? Size.space.md}>
      {validChildren.map((child, index) => {
        const key = child.key ?? index
        return (
          <React.Fragment key={`${key}-frag`}>
            {child}
            {divider &&
              index < validChildren.length - 1 &&
              cloneElement(isValidElement(divider) ? divider : <div>{divider}</div>, { key: `${key}-divider` })}
          </React.Fragment>
        )
      })}
    </Stack>
  )
}
